import {
  useGetCountriesWithAlpha,
  useGetEnergySource,
  useGetFertilizerData,
  useGetPesticideData,
  useGetProduceType
} from "../../../../../api/static-data";

export const useCultivationEditorOptions = () => {
  const { data: fertilizerList = [] } = useGetFertilizerData();
  const { data: pesticideList = [] } = useGetPesticideData();
  const { data: energySources = [] } = useGetEnergySource();
  const { data: produceTypes = [] } = useGetProduceType();
  const { data: countries = [] } = useGetCountriesWithAlpha();

  return { fertilizerList, pesticideList, energySources, produceTypes, countries };
};
